/* Presente (embalagens com switch) + recomendados do carrinho (Figma 322-24820/24773). */
if (!window.__cartFilipInit) {
  window.__cartFilipInit = true;

  function refreshCart(cart) {
    if (window.MinimogEvents && window.MinimogTheme) {
      window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart });
    }
    document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: cart } }));
  }

  function cartSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  function addVariant(variantId, done, fail) {
    const config = fetchConfig("javascript");
    config.method = "POST";
    config.body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: cartSections(),
      sections_url: window.location.pathname,
    });
    fetch(`${MinimogSettings.routes.cart_add_url}`, config)
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          if (fail) fail(response.description);
          return;
        }
        refreshCart(response);
        if (done) done(response);
      })
      .catch(() => fail && fail());
  }

  function setVariantQty(variantId, qty, done) {
    const config = fetchConfig("javascript");
    config.method = "POST";
    config.body = JSON.stringify({
      updates: { [variantId]: qty },
      sections: cartSections(),
      sections_url: window.location.pathname,
    });
    fetch(`${MinimogSettings.routes.cart_update_url}`, config)
      .then((r) => r.json())
      .then((response) => {
        refreshCart(response);
        if (done) done(response);
      });
  }

  function showCartError(root, message) {
    if (window.MinimogTheme && MinimogTheme.Notification && message) {
      MinimogTheme.Notification.show({
        target: root,
        method: "prepend",
        type: "error",
        message: message,
        last: 4000,
      });
    }
  }

  /* ── Presente: check único que adiciona/remove o produto do pedido ── */
  if (!customElements.get("m-cart-gift")) {
    customElements.define(
      "m-cart-gift",
      class MCartGift extends HTMLElement {
        connectedCallback() {
          this.addEventListener("click", (e) => {
            const main = e.target.closest("[data-gift-main]");
            if (main) this.toggle(main);
          });
        }

        toggle(btn) {
          if (btn.classList.contains("is-loading")) return;
          const variantId = this.dataset.variantId;
          if (!variantId) return;
          btn.classList.add("is-loading");
          if (btn.classList.contains("is-on")) {
            setVariantQty(variantId, 0, () => btn.classList.remove("is-loading"));
          } else {
            addVariant(
              variantId,
              () => btn.classList.remove("is-loading"),
              (msg) => {
                btn.classList.remove("is-loading");
                showCartError(this, msg);
              }
            );
          }
        }
      }
    );
  }

  /* ── Oferta pré-checkout: sheet abre ao clicar no CHECKOUT se faltar produto ── */
  if (!customElements.get("m-cart-precheckout")) {
    customElements.define(
      "m-cart-precheckout",
      class MCartPrecheckout extends HTMLElement {
        connectedCallback() {
          this.dirty = false;
          this.addEventListener("click", (e) => {
            if (e.target.closest("[data-sheet-close]")) {
              this.close();
              return;
            }
            if (e.target.closest("[data-sheet-checkout]")) {
              window.location.href = "/checkout";
              return;
            }
            const opt = e.target.closest("[data-gift-toggle]");
            if (opt) this.toggleOption(opt);
          });
        }

        get allSelected() {
          const toggles = [...this.querySelectorAll("[data-gift-toggle]")];
          return toggles.length === 0 || toggles.every((t) => t.classList.contains("is-on"));
        }

        maybeOpen() {
          if (this.allSelected) return false;
          this.hidden = false;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.classList.add("is-open"));
          });
          return true;
        }

        close() {
          this.classList.remove("is-open");
          setTimeout(() => {
            this.hidden = true;
            // sincroniza o drawer com o que foi adicionado/removido no sheet
            if (this.dirty) {
              this.dirty = false;
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
          }, 300);
        }

        /* sem re-render das sections aqui: o sheet precisa continuar aberto */
        toggleOption(btn) {
          if (btn.classList.contains("is-loading")) return;
          const variantId = btn.dataset.variantId;
          const isOn = btn.classList.contains("is-on");
          btn.classList.add("is-loading");
          const config = fetchConfig("javascript");
          config.method = "POST";
          config.body = JSON.stringify(
            isOn ? { updates: { [variantId]: 0 } } : { items: [{ id: variantId, quantity: 1 }] }
          );
          const url = isOn ? MinimogSettings.routes.cart_update_url : MinimogSettings.routes.cart_add_url;
          fetch(url, config)
            .then((r) => r.json())
            .then((response) => {
              btn.classList.remove("is-loading");
              if (response.status) {
                showCartError(this.querySelector(".m-cart-precheckout__sheet"), response.description);
                return;
              }
              this.dirty = true;
              btn.classList.toggle("is-on");
              btn.setAttribute("aria-checked", btn.classList.contains("is-on") ? "true" : "false");
            })
            .catch(() => btn.classList.remove("is-loading"));
        }
      }
    );
  }

  /* ── Intercepta o CHECKOUT do drawer: com oferta pendente, abre o sheet ── */
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest('.m-cart-drawer button[name="checkout"]');
      if (!btn || btn.disabled) return;
      const popup = document.querySelector("m-cart-precheckout");
      if (!popup) return;
      if (popup.maybeOpen()) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  /* ── Recomendados no carrinho: carrossel horizontal, disponíveis e fora do carrinho ── */
  // O refreshCart recria o elemento; sem isso o trilho volta pro começo a cada adição.
  let upsellScroll = 0;

  if (!customElements.get("m-cart-upsell")) {
    customElements.define(
      "m-cart-upsell",
      class MCartUpsell extends HTMLElement {
        connectedCallback() {
          this.load();
          this.addEventListener("click", (e) => {
            const btn = e.target.closest("[data-upsell-add]");
            if (!btn || btn.classList.contains("is-loading") || btn.classList.contains("is-added")) return;
            const track = this.querySelector("[data-upsell-items]");
            upsellScroll = track ? track.scrollLeft : 0;
            btn.classList.add("is-loading");
            addVariant(
              btn.dataset.variantId,
              () => {
                btn.classList.remove("is-loading");
                btn.classList.add("is-added");
              },
              (msg) => {
                btn.classList.remove("is-loading");
                showCartError(this, msg);
              }
            );
          });
        }

        load() {
          const seed = this.dataset.seed;
          const inCart = (this.dataset.cartProducts || "").split(",").filter(Boolean);
          const max = parseInt(this.dataset.max, 10) || 2;
          if (!seed) {
            this.hidden = true;
            return;
          }
          const base = `${MinimogSettings.routes.product_recommendations_url || "/recommendations/products"}.json?product_id=${seed}&limit=8`;
          const pick = (data) =>
            (data.products || []).filter((p) => p.available && !inCart.includes(String(p.id))).slice(0, max);
          // complementares primeiro; recomendados só se não sobrar nenhum complementar disponível
          fetch(`${base}&intent=complementary`)
            .then((r) => r.json())
            .then((data) => {
              const picks = pick(data);
              if (picks.length) return picks;
              return fetch(`${base}&intent=related`)
                .then((r) => r.json())
                .then(pick);
            })
            .then((picks) => {
              if (!picks.length) {
                this.hidden = true;
                return;
              }
              const track = this.querySelector("[data-upsell-items]");
              track.innerHTML = picks.map((p) => this.cardHTML(p)).join("");
              this.hidden = false;
              if (upsellScroll) track.scrollLeft = upsellScroll;
            })
            .catch(() => {
              this.hidden = true;
            });
        }

        cardHTML(p) {
          const img = p.featured_image
            ? `${p.featured_image}${p.featured_image.includes("?") ? "&" : "?"}width=300`
            : "";
          const money = (cents) =>
            "R$ " +
            (cents / 100)
              .toFixed(2)
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          const escapeAttr = (s) => String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
          const compare =
            p.compare_at_price && p.compare_at_price > p.price ? `<s>${money(p.compare_at_price)}</s>` : "";
          const variants = p.variants.filter((v) => v.available);
          const variantId = variants.length ? variants[0].id : p.variants[0].id;
          const addLabel = escapeAttr(`${this.dataset.addLabel || "Adicionar"} ${p.title}`);
          return `
            <div class="m-cart-upsell__card">
              <div class="m-cart-upsell__img">
                ${img ? `<img src="${img}" alt="" loading="lazy" width="140" height="112">` : ""}
                <button type="button" class="m-cart-upsell__add" data-upsell-add data-variant-id="${variantId}" aria-label="${addLabel}">
                  <svg class="m-cart-upsell__plus" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 2.5V7M7 7V11.5M7 7H2.5M7 7H11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  <svg class="m-cart-upsell__check" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M3 7.4L5.8 10L11 4.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
              </div>
              <div class="m-cart-upsell__info">
                <span class="m-cart-upsell__title">${p.title}</span>
                <span class="m-cart-upsell__price">${compare}<strong>${money(p.price)}</strong></span>
              </div>
            </div>`;
        }
      }
    );
  }
}
